import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import "./../my_styles/myStyles.css"; // We will create a separate CSS file for custom styles
import SendAReminder from "./SendAReminder";

function BookModel(props) {
  const show = props.show;
  const setShow = props.setShow;
  const event = props.eventDetails;

  const handleClose = () => setShow(false);

  const [showSendReminder, setShowSendReminder] = useState(false);
  return (
    <>
      <SendAReminder
        show={showSendReminder}
        setShow={setShowSendReminder}
        details={event}
      />
      <Modal
        show={show}
        onHide={handleClose}
        centered
        className="book-model-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Booking Details of {event.name}'s Cut</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="event-details mt-0">
            <div className="header ">Invoice</div>
            <ul className="details-list">
              <li>
                <strong>Customer:</strong>
                <span className="event-data">{event.name}</span>
              </li>
              <li>
                <strong>Date:</strong>
                <span className="event-data">{event.dateView}</span>
              </li>
              <li>
                <strong>Time:</strong>
                <span className="event-data">{event.time}</span>
              </li>
              <li>
                <strong>Mobile:</strong>
                <span className="event-data">{event.mobile}</span>
              </li>
              <li>
                <strong>Email:</strong>
                <span className="event-data">{event.email}</span>
              </li>

              <li>
                <strong>Barber:</strong>
                <span className="event-data">{event.barber}</span>
              </li>

              {/* Hair, Beard, Face services moved to the last */}
              {event.hair && (
                <li>
                  <strong>Hair:</strong>
                  <span className="event-data">
                    {event.hair} - <strong>${event.hair_price}</strong>
                  </span>
                </li>
              )}
              {event.beard && (
                <li>
                  <strong>Beard:</strong>
                  <span className="event-data">
                    {event.beard} - <strong>${event.beard_price}</strong>
                  </span>
                </li>
              )}
              {event.face && (
                <li>
                  <strong>Face:</strong>
                  <span className="event-data">
                    {event.face} - <strong>${event.face_price}</strong>
                  </span>
                </li>
              )}

              {/* Total Calculation */}
              <li className="total  mt-0">
                <strong>Total:</strong>
                <span className="event-data">
                  <strong>
                    $
                    {(
                      (parseFloat(event.hair_price) || 0) +
                      (parseFloat(event.beard_price) || 0) +
                      (parseFloat(event.face_price) || 0)
                    ).toFixed(2)}
                  </strong>
                </span>
              </li>
            </ul>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="success"
            onClick={() => setShowSendReminder(true)}
            className="close-btn m-0"
          >
            <span style={{ fontWeight: "bold" }}>Send A Reminder</span>
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default BookModel;
